import React from "react";
import "./Preloader.css";
import loaderLogo from "../../assets/img/loder.png"; // ✅ Update path if needed

const Preloader = () => {
  return (
    <div className="preloader-overlay">
      <div className="preloader-inner">
        <div className="preloader-circle"></div>
        <div className="preloader-img">
          <img src={loaderLogo} alt="Loading..." />
        </div>
      </div>
    </div>
  );
};

export default Preloader;
